// Boundary mapping for the server's `difficulty` string (returned by
// Typesense and by the Rails Hike model) onto a typed enum + a display
// colour. Kept in lock-step with Android's `Difficulty.kt` and iOS's
// `Difficulty.swift` so all three platforms paint the same hike with
// the same colour.

import { HiikerColor } from './HiikerColor';

export type Difficulty = 'Easy' | 'Medium' | 'Difficult' | 'Extra Difficult';

/** Server-string → enum value. Unknown / null falls back to Medium, matching
 *  the Android `Difficulty.fromString` and iOS `Difficulty.toServerString` defaults. */
export function difficultyFromString(value: string | null | undefined): Difficulty {
  switch (value) {
    case 'Easy':           return 'Easy';
    case 'Difficult':      return 'Difficult';
    case 'Extra Difficult': return 'Extra Difficult';
    case 'Medium':
    default:               return 'Medium';
  }
}

/** Returns the hex colour used to tint the difficulty label in info rows.
 *  Mirrors Android `Difficulty.toColor()` and iOS `Difficulty.toColor()`:
 *    Easy            → green
 *    Medium          → orange
 *    Difficult       → red
 *    Extra Difficult → purple
 */
export function difficultyColor(value: string | null | undefined): string {
  switch (difficultyFromString(value)) {
    case 'Easy':            return HiikerColor.green;
    case 'Medium':          return HiikerColor.orange;
    case 'Difficult':       return HiikerColor.red;
    case 'Extra Difficult': return HiikerColor.purple;
  }
}
